import { useCallback, useEffect, useState } from 'react';
import { getBootstrapStatus } from '../api/bootstrapApi';

export const useBootstrapStatus = ({ enabled, t }) => {
  const [status, setStatus] = useState({
    required: false,
    isChecking: false,
    errorMessage: '',
  });

  const refreshStatus = useCallback(async () => {
    if (!enabled) {
      return;
    }

    setStatus((prev) => ({ ...prev, isChecking: true, errorMessage: '' }));
    try {
      const response = await getBootstrapStatus();
      setStatus({
        required: Boolean(response?.required),
        isChecking: false,
        errorMessage: '',
      });
    } catch (error) {
      setStatus({
        required: false,
        isChecking: false,
        errorMessage: t('bootstrapStatusFailed'),
      });
    }
  }, [enabled, t]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    refreshStatus();
  }, [enabled, refreshStatus]);

  return { status, refreshStatus };
};
